import React, {useState} from 'react';
import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import AddPaymentMethod from './AddPaymentMethod';
import PopIn from '../../../common/components/PopIn';
import {withTranslation} from 'react-i18next';
import {TitleButton} from '../../../common/components/StyledComp';
import {useQuery} from 'react-apollo';
import {PulseLoader} from 'react-spinners';
import gql from 'graphql-tag';
import styled from 'styled-components';

const CenteredDiv = styled.div`
  text-align: center;
`;

const GRAPHQL_QUERY_USER_PAYMENT_METHOD = gql`
  query userPaymentMethod($id: ID!) {
    user(id: $id) {
      id
      hasValidPaymentMethod
      paymentMethod {
        id
        card {
          id
          brand
          expMonth
          expYear
          last4
        }
      }
    }
  }
`;

const PaymentMethodManagement = ({t, userId}) => {
  const [displayCardForm, setDisplayCardForm] = useState(false);
  const [addPaymentProcess, setAddPaymentProcess] = useState(false);
  const {loading, error, data} = useQuery(GRAPHQL_QUERY_USER_PAYMENT_METHOD, {
    variables: {id: userId},
    fetchPolicy: 'cache-and-network',
  });

  if (loading) {
    return <PulseLoader/>;
  }
  if (error) {
    console.error(error);
    return null;
  }

  const user = data && data.user;
  const paymentMethod = data && data.user && data.user.paymentMethod ? data.user.paymentMethod : null;
  return (
    <>
      <CenteredDiv>
        <p>
          {user.hasValidPaymentMethod ? (
            t('paymentManagement.valid', {
              brand: paymentMethod.card.brand,
              last4: paymentMethod.card.last4,
              expMonth: paymentMethod.card.expMonth,
              expYear: paymentMethod.card.expYear,
            })
          ) : (
            paymentMethod === null ? (
              t('paymentManagement.invalid')
            ) : (
              t('paymentManagement.invalidWithCard', {
                brand: paymentMethod.card.brand,
                last4: paymentMethod.card.last4,
                expMonth: paymentMethod.card.expMonth,
                expYear: paymentMethod.card.expYear,
              })
            )
          )}
        </p>
        <div className="popin-buttons">
          <TitleButton onClick={() => setDisplayCardForm(true)}>{paymentMethod === null ? t('paymentManagement.add') : t('paymentManagement.change')}</TitleButton>
        </div>
      </CenteredDiv>
      <PopIn title={t('paymentManagement.information')} visible={displayCardForm} setModalVisible={value => !addPaymentProcess && setDisplayCardForm(value)} size={'lg'}>
        <AddPaymentMethod
          userId={userId}
          onStart={() => setAddPaymentProcess(true)}
          onError={() => setAddPaymentProcess(false)}
          onComplete={() => {
            setAddPaymentProcess(false);
            setDisplayCardForm(false);
          }}
          onCancel={() => setDisplayCardForm(false)}
        />
      </PopIn>
    </>
  );
};

PaymentMethodManagement.propTypes = {
  t: PropTypes.func.isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default compose(
  withTranslation('stripe'),
)(PaymentMethodManagement);
